import React from "react";
import { withRouter } from "react-router-dom";
import withMUI from "../hoc/withMUI";
import BottomNavigation from "../components/BottomNavigation";
import AppBar from "../components/AppBar";

class Layout extends React.Component {
  render() {
    const {
      appBar,
      showAppBar,
      bottomNavigation,
      children,
      dark,
      appBarTitle,
      showMoreIcon,
      appBarEvent,
      dropDownCurrentStore,
      handleBack,
      selectedValue,
      AppBarGoBackHandler,
      notificationIcon,
      dropDownHandler,
      appBarRightIcon,
      appBarLeftIcon,
      isStepper,
      isAppbarTitleCenter
    } = this.props;
    const top = appBar && (
      <AppBar
        dark
        mode={dark}
        appBarTitle={appBarTitle}
        showMoreIconHere={showMoreIcon}
        isShowAppBar={showAppBar}
        appBarEventShow={appBarEvent}
        handleBack={handleBack}
        AppBarGoBackHandler={AppBarGoBackHandler}
        notificationIcon={notificationIcon}
        dropDownCurrentStore={dropDownCurrentStore}
        dropDownHandler={dropDownHandler}
        appBarRightIcon={appBarRightIcon}
        appBarLeftIcon={appBarLeftIcon}
        isStepper={isStepper}
        isAppbarTitleCenter={isAppbarTitleCenter}
      />
    );
    const bottom = bottomNavigation && (
      <BottomNavigation
        selectedValue={selectedValue}
        dropDownCurrentStore={dropDownCurrentStore}
      />
    );
    return (
      <div>
        {top}
        {children}
        {bottom}
      </div>
    );
  }
}

export default withRouter(withMUI(Layout));
